module.exports = __webpack_public_path__ + "img/img66.b64b9375.png";